import { NavLink, Link } from "react-router-dom";
import { Logo } from "./Logo";

export const Nav = () => (
  <header className="site-nav" data-testid="site-nav">
    <Link to="/" className="nav-logo" data-testid="nav-logo-link" aria-label="Cactus — Home">
      <Logo size={42} />
    </Link>
    <nav className="nav-links">
      <NavLink to="/work" data-testid="nav-work-link" className={({ isActive }) => (isActive ? "active" : "")}>
        Work
      </NavLink>
      <NavLink to="/studio" data-testid="nav-studio-link" className={({ isActive }) => (isActive ? "active" : "")}>
        Studio
      </NavLink>
      <NavLink to="/contact" data-testid="nav-contact-link" className={({ isActive }) => (isActive ? "active" : "")}>
        Contact
      </NavLink>
    </nav>
  </header>
);
